<template>
  <parallax-container>
    <div v-if="this.$mq!=='mobile'">
      <parallax-element :parallaxStrength="15" :type="'translation2'" class="left-top_1 "></parallax-element>
    <parallax-element :parallaxStrength="10" :type="'translation2'" class="left-top_2 "></parallax-element>
    <parallax-element :parallaxStrength="10" :type="'translation2'" class="left-bot_1 "></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation2'" class="left-bot_2 "></parallax-element>
    <parallax-element :parallaxStrength="10" :type="'translation2'" class="right-bot_1"></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation2'" class="right-bot_2"></parallax-element>
    <parallax-element :parallaxStrength="14" :type="'translation2'" class="right-top_1"></parallax-element>
    <parallax-element :parallaxStrength="16" :type="'translation2'" class="right-top_2"></parallax-element>
    </div>

    <slot></slot>
  </parallax-container>
</template>

<script>
    import parallaxContainer from "../parallax/parallax-container.vue";
    import parallaxElement from "../parallax/parallax-element.vue";

    export default {
        name: "Curtains",
        components: {
            parallaxContainer,
            parallaxElement,

        }
    }
</script>

<style scoped lang="scss">


  .left-top_1 {
    position: fixed;
    height: 35vh;
    width: 48vh;
    top: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/test/left_top_1.png");
    background-size: cover;
    z-index: 200;
  }

  .left-top_2 {
    position: fixed;
    height: 44vh;
    width: 58vh;
    top: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/test/left_top_2.png");
    background-size: cover;
    z-index: 190;
  }

  .left-bot_1 {
    position: fixed;
    height: 81vh;
    width: 44vh;
    bottom: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/test/left_bot_1.png");
    background-size: cover;
    z-index: 200;
  }

  .left-bot_2 {
    position: fixed;
    height: 73vh;
    width: 33vh;
    bottom: -10vh;
    left: -10vh;
    background-image: url("../../assets/images/curtains/test/left_bot_2.png");
    background-size: cover;
    z-index: 190;
  }

  .right-bot_1 {
    position: fixed;
    height: 45vh;
    width: 36vh;
    bottom: -10vh;
    right: -10vh;
    background-image: url("../../assets/images/curtains/test/right_bot_1.png");
    background-size: cover;
    z-index: 200;
  }

  .right-bot_2 {
    position: fixed;
    height: 48vh;
    width: 42vh;
    bottom: -10vh;
    right: -10vh;
    background-image: url("../../assets/images/curtains/test/right_bot_2.png");
    background-size: cover;
    z-index: 190;
  }

  .right-top_1 {
    position: fixed;
    height: 58vh;
    width: 122vh;
    top: -10vh;
    right: -10vh;
    background-image: url("../../assets/images/curtains/test/right_top_1.png");
    background-size: cover;
    z-index: 200;
  }

  .right-top_2 {
    position: fixed;
    height: 53vh;
    width: 105vh;
    top: -10vh;
    right: -10vh;
    background-image: url("../../assets/images/curtains/test/right_top_2.png");
    background-size: cover;
    z-index: 190;
  }


</style>